import store from '@/store'
import { acceptLanguageHeader, signRequest, signRequesWebApi, addTimestampHeader } from './authorization'
import { EventBus } from '@/utils/eventBus'

let count = 0

const onSuccess = (response) => {
  count--
  store.dispatch('app/setLoading', (count !== 0))
  return response
}

const onError = (error, ignoreUnauthorized = false) => {
  count--
  store.dispatch('app/setLoading', (count !== 0))
  if (!ignoreUnauthorized && error.response && error.response.status === 401) {
    EventBus.emitUnauthorizedEvent()
  }
  return Promise.reject(error)
}

const signbeforeRequestSuccess = (config) => {
  count++
  acceptLanguageHeader(config)
  signRequest(config)
  store.dispatch('app/setLoading', (count !== 0))
  return config
}

const signbeforeRequestSuccessGraphQL = (config) => {
  count++
  acceptLanguageHeader(config)
  config.url = config.pathToBeSetAsUrl // url can't be set before this because it gets overwride
  signRequest(config)
  return config
}

const signbeforeRequestSuccessWebApi = (config) => {
  count++
  acceptLanguageHeader(config)
  signRequesWebApi(config)
  store.dispatch('app/setLoading', (count !== 0))
  return config
}

const noAuthBeforeRequestSuccess = (config) => {
  count++
  addTimestampHeader(config)
  store.dispatch('app/setLoading', (count !== 0))
  return config
}

const beforeRequestSuccess = (config) => {
  count++
  store.dispatch('app/setLoading', (count !== 0))
  return config
}

const beforeRequestError = (error) => {
  count--
  store.dispatch('app/setLoading', (count !== 0))
  return Promise.reject(error)
}

export {
  onSuccess,
  onError,
  signbeforeRequestSuccess,
  signbeforeRequestSuccessWebApi,
  signbeforeRequestSuccessGraphQL,
  noAuthBeforeRequestSuccess,
  beforeRequestSuccess,
  beforeRequestError
}



// WEBPACK FOOTER //
// ./src/api/interceptors.js